require('./capability-ng-course-schedule-module');

require('./builders/course_builder');
require('./builders/display_data_builder');
require('./builders/location_builder');
require('./builders/schedule_builder');
require('./builders/schedule_section_builder');
require('./builders/schedule_terms_builder');
require('./builders/section_time_builder');

require('./commands/add_courses_to_calendar_command');
require('./commands/course_detail_command');
require('./commands/load_course_list_command');

require('./components/my_schedule_course/my_schedule_course_controller');
require('./components/my_schedule_course_list/my_schedule_course_list_controller');
require('./components/my_schedule_detail/my_schedule_detail_component');
require('./components/my_schedule_detail/my_schedule_detail_controller');
require('./components/my_schedule_list/my_schedule_list_component');
require('./components/my_schedule_list/my_schedule_list_controller');

require('./databases/course_schedule_database');
require('./datasources/schedule_datasource');
require('./datasources/schedule_sections_datasource');
require('./datasources/schedule_terms_datasource');

require('./functions/my_schedule_detail_fn');
require('./functions/my_schedule_fn');
require('./functions/my_schedule_native_calendar_fn');

require('./queries/queries_module');
require('./queries/schedule_priority_feed_query');
require('./queries/schedule_query');

require('./services/calendar_integration_service');
require('./services/nums_to_day_names');

require('./types/days_of_week');
require('./types/my_schedule_types');

require('./views/my_schedule_detail_view/my_schedule_detail_view_controller');
require('./views/my_schedule_list_view/my_schedule_list_view_controller');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/core.ts